import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';
import Button from '../Button';

interface ConfirmationFormRoutingProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmationFormRouting: React.FC<ConfirmationFormRoutingProps> = ({
  open,
  onClose,
  onConfirm
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("common.confirmation")}
      content={t("common.unsavedChangesWarning")}
      action={
        <>
          <Button
            className="btn btn-outline-secondary me-3"
            text={t("common.no")}
            onClick={onClose}
          />
          <Button
            className="btn btn-warning"
            text={t("common.yes")}
            onClick={onConfirm}
          />
        </>
      }
      contentClassName="text-center"
      maxWidth="sm"
    />
  );
};

export default ConfirmationFormRouting;
